// Helper function to validate user uploads 5 pictures
export const interestImageValidator = (_: any, value: any) => {
  if (!value || value?.length === 0) {
    return Promise.resolve();
  }
  if (value?.length === 5) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('5 pictures must be uploaded'));
};
